import styled from 'styled-components'
import { redirectToSearch, stripTags } from './helpers'

const List = styled.div`
    width: calc(100% + 4px);
    padding: 5px 0;
    margin: 0;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0px 8px 8px rgba(0, 0, 0, .15);
    background: #FFF;

    position: absolute;
    top: 56px;
    left: -2px;
    display: flex;
    flex-direction: column;
    z-index: 2;

    @media screen and (min-width: 640px) {
        width: calc(100% - 98px);
    }

    @media screen and (min-width: 960px) {
        width: calc(100% - 92px);
    }
`

const Row = styled.div`
    height: 32px;
    min-width: 0;

    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #707070;
    
    background: #FFF;
    border-radius: 4px;
    padding: 0 10px;
    margin: 0 6px;

    display: flex;
    align-items: center;
    overflow: hidden;
    
    cursor: pointer;
    text-decoration: none;
    user-select: none;
    transition: background .2s, color .2s;

    @media screen and (min-width: 961px) {
        font-size: 14px;
        line-height: 32px;
    }

    &:not(.also).selected, &:not(.also):hover {
        background: #F5F5F5;
        color: #262626;
    }

    &.also.selected, &.also:hover {
        background: #38A5B9;
        color: #FFF;
    }
`

const RowTitle = styled.div`
    height: 56px;
    font-family: Roboto, sans-serif;;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    line-height: 16px;
    color: #707070;

    padding: 0 10px 8px;
    margin: 0 6px;

    display: flex;
    align-items: flex-end;
    white-space: nowrap;
    overflow: hidden;

    cursor: default;
    user-select: none;

    position: relative;
    min-width: 0;

    @media screen and (min-width: 961px) {
        font-size: 12px;
        line-height: 14px;
    }

    &:before {
        content: " ";
        position: absolute;
        top: 12px;
        width: calc(100% - 20px);
        height: 1px;
        background-color: #F4F3F4;

    }
`

const Link = styled.a`
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    white-space: nowrap;

    color: inherit;
    text-decoration: inherit;

    &hover: {
        background: #F4F3F4;
    }
`

type Props = {
    suggestions: {name: string, id: number}[],
    tags: {id: number, name: string, link: string}[],
    isMouseHover: (arg: boolean) => void
    selectSuggestions: any
}

let selected: number = -1;
let isPressed: boolean = false;

const Suggestions = ({ suggestions, tags, isMouseHover, selectSuggestions }:Props) => {
    const select = (direction: string) => {
        switch (direction.toLowerCase()) {
            case 'down':
                if (!isPressed) {
                    isPressed = true
                    if (selected < 0) selected = 1
                    else selected++
                }
                break
            case 'up':
                if (!isPressed) {
                    isPressed = true
                    if (selected < 0) selected = 0
                    else selected--
                }
                break
            case 'enter':
                if (!isPressed) {
                    isPressed = true
                    if (suggestions[selected - 1])
                        redirectToSearch(stripTags(suggestions[selected - 1].name))
                    else if (tags[selected - suggestions.length - 1])
                        window.location.href = stripTags(tags[selected - suggestions.length - 1].link)
                    else redirectToSearch(stripTags(suggestions[0].name))
                } 
                break
            default:
                isPressed = false
                break
        }

        if (selected < 0) return {}
        if (selected > suggestions.length + tags.length) selected = 1
        if (selected === 0) selected = suggestions.length + tags.length
        if (selected <= suggestions.length) return { suggestions: selected - 1, selected: selected }
        return { tags: selected - suggestions.length - 1, selected: selected }
    }

    if (suggestions.length === 0) {
        return null
    }

    return <List
        onMouseEnter={() => isMouseHover(true)}
        onMouseLeave={() => isMouseHover(false)}
    >
        {
            suggestions.map(function(s, i) {
                return <Row
                    key={s.id}
                    className={"suggestions" in select(selectSuggestions) && i === select(selectSuggestions).suggestions ? "selected" : ""}
                >
                    <Link
                        href={stripTags(`/search/?search_q=${s.name}`)}
                        dangerouslySetInnerHTML={{__html: s.name}}
                    />
                </Row>
            })
        }
        {
            tags.length > 0 &&
            <>
                <RowTitle>Also in Tags</RowTitle>
                
                {tags.map(function(t, i) {
                    return <Row
                        className={
                            "tags" in select(selectSuggestions) && i === select(selectSuggestions).tags ? "selected also" : "also"}
                        key={t.id}
                    >
                        <Link
                            href={t.link}
                            dangerouslySetInnerHTML={{ __html: t.name }}
                        />
                    </Row>
                })}
            </>
        }
    </List>
}

export default Suggestions